"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.observeBounds = exports.isDomRectEqual = void 0;
const isDomRectEqual = (a, b) => {
    if (a.top !== b.top ||
        a.left !== b.left ||
        a.width !== b.width ||
        a.height !== b.height ||
        a.x !== b.x ||
        a.y !== b.y) {
        return false;
    }
    return true;
};
exports.isDomRectEqual = isDomRectEqual;
/**
 * Observes the bounding client box rectangle of the given element for changes.
 *
 * This solution only works for 2 scenarios, though could be updated to support more
 * (e.g. via polling).
 *
 * MutationObserver will only pick up changes to bounds if they are specified via fixed
 * style rules in the element's attribtues.
 *
 * ResizeObserver will pick up all changes to an element's width and height but will not capture
 * any changes to position.
 *
 * @param element The element to observe the bounding box for (i.e. position, width, height)
 * @param onChange Called every time the bounding box changes.
 * @returns Function which disposes the observers when invoked.
 * @ignore
 */
const observeBounds = (element, onChange) => {
    let lastBounds;
    const checkBounds = async () => {
        const currentBounds = element.getBoundingClientRect();
        if (!lastBounds || !(0, exports.isDomRectEqual)(lastBounds, currentBounds)) {
            lastBounds = currentBounds;
            await onChange(element.getBoundingClientRect());
        }
    };
    const resizeObserver = new ResizeObserver(() => checkBounds());
    const mutationObserver = new MutationObserver(() => checkBounds());
    resizeObserver.observe(element, { box: 'content-box' });
    mutationObserver.observe(element, { attributes: true, attributeFilter: ['style'] });
    checkBounds();
    return () => {
        resizeObserver.disconnect();
        mutationObserver.disconnect();
    };
};
exports.observeBounds = observeBounds;
